import { FC } from 'react';

import { CallFinished } from '../CallFinished/CallFinished';
import { BackgroundImage } from './Components/BackgroundImage/BackgroundImage';
import { WrapperContent } from './Components/WrapperContent/WrapperContent';

export const CallFinishedPage: FC = () => {
  return (
    <>
      <BackgroundImage />
      <WrapperContent>
        <CallFinished />
      </WrapperContent>
    </>
  );
};
